import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProductSlider from '../components/ProductSlider'; // Slider per i prodotti
import StoreSlider from '../components/StoreSlider'; // Slider per i negozi
import SearchBar from '../components/SearchBar';
import { useEventTracking } from '../hooks/useAnalytics';
import SEOMetadata from '../components/SEOMetadata';
import { SEO_CONFIG } from '../config/seo';
import './HomePage.css';

const HomePage = () => {
  const { trackEvent } = useEventTracking();

  // Traccia la visualizzazione della homepage (pageview automatico già gestito dal hook)
  useEffect(() => {
    trackEvent('homepage_view', {
      page_title: 'Home',
      page_location: '/',
      page_type: 'home'
    });
  }, [trackEvent]);

  // SEO Metadata
  const seoData = {
    title: 'Loverlist - Confronta Prezzi e Trova le Migliori Offerte Online',
    description: 'Scopri Loverlist, il comparatore di prezzi che ti aiuta a trovare i prodotti al prezzo più basso. Confronta offerte da migliaia di negozi online e risparmia sui tuoi acquisti.',
    keywords: 'comparatore prezzi, confronta prezzi, offerte online, shopping online, risparmio, ecommerce, prodotti scontati',
    canonical: `${SEO_CONFIG.baseUrl}/`,
    ogImage: SEO_CONFIG.defaultOgImage,
    ogType: 'website',
    structuredData: [
      SEO_CONFIG.structuredData.website,
      SEO_CONFIG.structuredData.organization
    ]
  };

  return (
    <>
      <SEOMetadata {...seoData} />
      <main className="home-page">
      {/* Hero Section - Apertura */}
      <section className="homepage-hero">
        <div className="main-content-container">
          <div className="hero-image-col floating-hero-images">
            <div className="floating-img floating-img-1">
              <img src="/media/assets/Home Hero_Tavola disegno 1.png" alt="Hero 1" className="homepage-hero-img" />
            </div>
            <div className="floating-img floating-img-2">
              <img src="/media/assets/Home Hero-02.png" alt="Hero 2" className="homepage-hero-img" />
            </div>
            <div className="floating-img floating-img-3">
              <img src="/media/assets/Home Hero-03.png" alt="Hero 3" className="homepage-hero-img" />
            </div>
          </div>
          <div className="hero-text-col">
            <h1 className="homepage-hero-title">Confronta le offerte di migliaia di ecommerce</h1>
            <h2 className="homepage-hero-subtitle">Compara i prezzi dei prodotti che ami</h2>
            <div className="homepage-searchbar-hero" style={{zIndex:20, position:'relative'}}>
              <SearchBar variant="hero" />
            </div>
          </div>
        </div>
        {/* Onda decorativa in fondo */}
        <div className="homepage-hero-wave">
          <svg viewBox="0 0 1440 90" width="100%" height="90" preserveAspectRatio="none">
            <path fill="#c93249" d="M0,60 C360,120 1080,0 1440,60 L1440,90 L0,90 Z" />
            <path fill="#f9f9f9" d="M0,80 C400,120 1040,20 1440,80 L1440,90 L0,90 Z" />
          </svg>
        </div>
      </section>

      {/* Lista dei negozi */}
      <section className="homepage-stores">
        <div className="main-content-container">
          <StoreSlider />
        </div>
      </section>

      {/* Testo comparatore */}
      <section className="homepage-about">
        <div className="main-content-container">
          <h2 className="homepage-about-title">Cos'è Loverlist?</h2>
          <p className="homepage-about-text">
            Loverlist è il comparatore di prezzi che ti aiuta a trovare il prodotto giusto al prezzo più basso. Confronta offerte, scopri promozioni e scegli sempre il meglio per te!
          </p>
        </div>
      </section>

      {/* Benefici per i venditori */}
      <section className="homepage-benefits">
        <div className="main-content-container">
          <div className="homepage-benefits-content">
            <div className="homepage-benefits-image-col">
              <img src="/home_cose.png" alt="Vendi su Loverlist" className="homepage-benefits-image" />
            </div>
            <div className="homepage-benefits-text-col">
              <h3 className="homepage-benefits-title">Hai un ecommerce? Unisciti a Loverlist!</h3>
              <ul className="homepage-benefits-list">
                <li>Raggiungi nuovi clienti ogni giorno</li>
                <li>Integrazione via Shopify, WooCommerce, Magento o feed</li>
                <li>E' gratis! Siamo un comparatore di prezzi, non un marketplace</li>
                <li>Se vuoi, siamo il tuo partner CSS Google</li>
              </ul>
              <Link 
                to="/sign-up-seller" 
                className="homepage-benefits-cta"
                onClick={() => trackEvent('/', '/sign-up-seller', 'cta')}
              >
                Iscrivi il tuo negozio
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Griglia ultimi prodotti aggiunti */}
      <section className="homepage-latest-products">
        <div className="main-content-container">
          <h2 className="homepage-latest-title">Illuminazione bagno</h2>
          <ProductSlider categoryHandle="illuminazione-bagno-1" />
        </div>
      </section>
    </main>
    </>
  );
};

export default HomePage;
